<i18n>
  {
    "en": {
      "dinerSpending": "Average spending by customer"
    },
    "es": {
      "dinerSpending": "Gasto medio por comensal"
    }
  }
</i18n>

<script>
import Component from 'vue-class-component';
import { MapActions } from '@core/helpers/decorators';
import KpiComponent from './KpiComponent.vue';
import * as KPITypes from '../constants';

@Component
@MapActions(['calculateDinerRevenueKPI'])
export default class DinerSpendingKpi extends KpiComponent {
  icon = 'mdi-account-cash'

  kpiType = KPITypes.DINER_REVENUE

  isCurrencyUnit = true

  get title() {
    return this.$t('dinerSpending');
  }

  async calculate() {
    await this.calculateDinerRevenueKPI({ pointOfSaleGuid: this.$route.params.pointOfSaleGuid, isManaged: this.isManaged });
    this.loadKPIModel();
  }
}
</script>
